import React from "react";

class Form extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      fields: {
        name: "",
        subject: "",
        phone: "",
        email: "",
        message: ""
      },
      errors: {
        name: "",
        subject: "",
        phone: "",
        email: "",
      },
    };
  }

  handleChange = (event) => {
    let name = event.target.name;
    let value = event.target.value;
    let fields = this.state.fields;
    let errors = this.state.errors;

    switch (name) {
      case "name":
        fields.name = value;
        errors.name = value.length === 0 ? "Name ist leer / name is empty" : "";
        break;
      case "subject":
        fields.subject = value;
        errors.subject = value.length < 5 ? "Subject must be 5 characters" : "";
        break;
      case "phone":
        fields.phone = value;
        errors.phone = value.length < 5 ? "Tel-Nr. ist leer / phone is empty" : "";
        break;
      case "email":
        fields.email = value;
        errors.email = value.length < 5 ? "Betreff ist leer / subject is empty" : "";
        let appos = value.indexOf("@");
        let dots = value.lastIndexOf(".");

        if (appos < 1 || dots - appos < 2) {
          errors.email = "please enter valid email";
        }

        break;
      case "message":
        fields.message = value;
        break;
      default:
        break;
    }
    this.setState({ errors, [name]: value });
  };

  submitHandler = (e) => {
    e.preventDefault();
    if (
      this.state.errors.name.length === 0 &&
      this.state.errors.subject.length === 0 &&
      this.state.errors.phone.length === 0 &&
      this.state.errors.email.length === 0
    ) {
    } else {
      alert("form is invalid");
    }

    window.open(`mailto:office@gebetsroither.com?subject=${this.state.fields.subject}&body=${this.state.fields.message}`);
  };

  render() {
    const { errors } = this.state;
    return (
      <form onSubmit={this.submitHandler.bind(this)} className="form_class">
        <div className="row">
          <div className="col-lg-12">
            <input
              type="text"
              id="subject"
              name="subject"
              className="form-control"
              placeholder="Betreff / Subject*"
              onChange={this.handleChange}
            />
            <p>{errors.subject}</p>
          </div>
        </div>
        <textarea
          name="message"
          id="message"
          className="form-control"
          rows="6"
          placeholder="Ihre Nachricht / Your Message"
          onChange={this.handleChange}
        ></textarea>
        <button type="submit" className="btn send_btn theme_btn">
          <strong>Nachricht senden</strong><br />Send message
        </button>
      </form>
    );
  }
}

export default Form;
